module.exports = __webpack_public_path__ + "img/barry-smc.de2098ac.jpg";